var _rect, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAlTag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 16,
    viewBox: "0 0 26 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 25,
    height: 16,
    rx: 8,
    fill: "url(#paint0_linear_3136_18969)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.364 12L12.836 10.704H9.164L8.636 12H6.656L10.016 3.756H11.996L15.356 12H13.364ZM9.776 9.204H12.224L11 6.192L9.776 9.204ZM16.3517 12V3.756H18.1277V12H16.3517Z",
    fill: "#F1F1F1"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3136_18969",
    x1: 0.5,
    y1: 8,
    x2: 25.5,
    y2: 8,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A5219F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D98477"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlTag);
export default __webpack_public_path__ + "static/media/Al-Tag.d34e8503178fc84209062d48cdf5e4cc.svg";
export { ForwardRef as ReactComponent };